module.exports = __webpack_public_path__ + "img/itx-file-type-rar.434e251a.svg";